var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#12100e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m122.18 171.23c0.428-4.222-1.182-8.397-4.335-11.238l-32.117-38.689v-5.779h99.719l77.078 169.04 67.765-169.04h95.062v5.779l-27.459 26.327c-2.369 1.804-3.542 4.771-3.051 7.707v193.44c-0.491 2.936 0.682 5.903 3.051 7.706l26.815 26.328v5.779h-134.88v-5.779l27.779-26.971c2.731-2.728 2.731-3.531 2.731-7.704v-156.36l-77.238 196.17h-10.437l-89.926-196.17v131.48c-0.748 5.527 1.087 11.094 4.978 15.09l36.132 43.824v5.779h-102.45v-5.779l36.131-43.824c3.863-4.004 5.59-9.607 4.656-15.09v-152.02z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a0a7c3bff3ece900730284c1fb857bf8.svg";
export { ForwardRef as ReactComponent };